// eslint-disable-next-line no-unused-vars
import * as React from 'react';

const MaterialIconsLogo = ( props ) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={ 48 } height={ 48 } viewBox="0 0 48 48" { ...props }>
		<path fill="#29b6f6" d="m1 5 6 4v20l-6-4z" />
		<path
			fill="#0288d1"
			d="m47 20-6 4v13l6-4zM47 6l-6 4v7l6-4zM35 5l-6 4v20l6-4z"
		/>
		<path fill="#29b6f6" d="m1 12 17 11v-7L1 5z" />
		<path
			fill="#0288d1"
			d="M35 12 18 23v-7L35 5zM35 26 18 37v-7l17-11zM47 34 30 45v-7l17-11z"
		/>
		<path fill="#29b6f6" d="M30 37.765 18 30v7l12 7.765z" />
	</svg>
);

export default MaterialIconsLogo;
